import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { getCitiesByCountry } from '../../services/SelectorsService';
import { useLanguage } from '../../i18n/LanguageContext';

function Jobfindbox({ selectors = {}, filters = {}, onSearch }) {
	const [localFilters, setLocalFilters] = useState({
		query: filters.query || '',
		categoriaId: filters.categoriaId || '',
		ciudadId: filters.ciudadId || '',
		paisId: filters.paisId || ''
	});
	const [availableCities, setAvailableCities] = useState([]);

	const { t } = useLanguage();

	// Sincronizar con props cuando cambian
	useEffect(() => {
		setLocalFilters({
			query: filters.query || '',
			categoriaId: filters.categoriaId || '',
			ciudadId: filters.ciudadId || '',
			paisId: filters.paisId || ''
		});
	}, [filters]);

	// Cargar ciudades cuando cambia el país
	useEffect(() => {
		const loadCities = async () => {
			if (localFilters.paisId) {
				try {
					const response = await getCitiesByCountry(localFilters.paisId);
					setAvailableCities(response.data || []);
				} catch (err) {
					console.error('Error loading cities:', err);
					setAvailableCities([]);
				}
			} else {
				setAvailableCities([]);
			}
		};

		loadCities();
	}, [localFilters.paisId]);

	// Inicializar animaciones de placeholder
	useEffect(() => {
		var i = 0;
		
		// Placeholder Animation Start
		var inputSelector = document.querySelectorAll('input, textarea');
		
		for (i = 0; i < inputSelector.length; i++) {
			inputSelector[i].addEventListener('focus', function(event) {
				return this.parentElement.parentElement.classList.add("focused");
			});
		}
		
		for (i = 0; i < inputSelector.length; i++) {
			inputSelector[i].addEventListener('blur', function(event) {
				var inputValue = this.value;	
				if ( inputValue === '' ) {
					this.parentElement.parentElement.classList.remove('filled');
					this.parentElement.parentElement.classList.remove('focused');  
				} else {
					this.parentElement.parentElement.classList.add('filled');
				}
			});
		}
		
		// Placeholder Animation End
	}, []);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setLocalFilters(prev => ({
			...prev,
			[name]: value
		}));

		// Si cambia el país, limpiar ciudad
		if (name === 'paisId') {
			setLocalFilters(prev => ({
				...prev,
				paisId: value,
				ciudadId: ''
			}));
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (onSearch) {
			onSearch(localFilters);
		}
	};

	return (
		<div className="section-full browse-job-find">
			<div className="container">
				<div className="find-job-bx">
					<form className="dezPlaceAni" onSubmit={handleSubmit}>
						<div className="row">
							<div className="col-lg-10 col-md-8 " style={{ width: '100%' }}>
								<div className="form-group">
									<label>{t('jobsection.searchInputLabel')}</label>
									<div className="input-group">
										<input
											type="text"
											className="form-control"
											placeholder=""
											name="query"
											value={localFilters.query}
											onChange={handleInputChange}
										/>
										<div className="input-group-append">
											<span className="input-group-text"><i className="fa fa-search"></i></span>
										</div>
									</div>
								</div>
							</div>
							{false &&<div className="col-lg-3 col-md-6">
								<div className="form-group">
									<label>Ciudad</label>
									<div className="input-group">
										<Form.Control
											as="select"
											className="form-control"
											name="ciudadId"
											value={localFilters.ciudadId}
											onChange={handleInputChange}
											disabled={!localFilters.paisId}
										>
											<option value="">
												{localFilters.paisId ? 'Seleccione una ciudad' : 'Primero seleccione un país'}
											</option>
											{availableCities.map((ciudad) => (
												<option key={ciudad.id} value={ciudad.id}>
													{ciudad.nombre}
												</option>
											))}
										</Form.Control>
										<div className="input-group-append">
											<span className="input-group-text"><i className="fa fa-map-marker"></i></span>
										</div>
									</div>
								</div>
							</div>}
							{false && <div className="col-lg-3 col-md-6">
								<div className="form-group">
									<label>Categoría</label>
									<Form.Control
										as="select"
										custom
										className="select-btn"
										name="categoriaId"
										value={localFilters.categoriaId}
										onChange={handleInputChange}
									>
										<option value="">Selecciona una categoría</option>
										{selectors.categorias && selectors.categorias.map((categoria) => (
											<option key={categoria.id} value={categoria.id}>
												{categoria.nombre}
											</option>
										))}
									</Form.Control>
								</div>
							</div>}
							<div className="col-lg-2 col-md-4">
								<button type="submit" className="site-button btn-block">{t('jobsection.searchButton')}</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}
export default Jobfindbox;
